import Slider from '../components/slider';

export default {
  init() {
    // JavaScript to be fired on the home page
    let heroSlider = new Slider($('[data-control="hero-slider"]'), 'hero')
    heroSlider.init()
    let styleSlider = new Slider($('[data-control="style-slider"]'), 'style')
    styleSlider.init()
    let productsSlider = new Slider($('[data-control="products-slider"]'), 'products')
    productsSlider.init()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js